<template>
  <div class="element-flip">
    <SelectButton :options="options" v-model="flipOptionsSelected" optionLabel="value" dataKey="value" aria-labelledby="basic">
      <template #option="slotProps">
        <div @click="slotProps.option.command">
          <component :is="slotProps.option.icon"></component>
          {{ slotProps.option.value }}
        </div>
      </template>
    </SelectButton>
  </div>
</template>

<script lang="ts" setup>
import { ref, watch } from 'vue'
import { storeToRefs } from 'pinia'
import { useMainStore, useSlidesStore } from '@/store'
import { ImageOrShapeFlip } from '@/types/slides'
import useHistorySnapshot from '@/hooks/useHistorySnapshot'
import useMicroservice from "@/hooks/useMicroservice.ts";
const api = useMicroservice()

const slidesStore = useSlidesStore()
const { handleElement } = storeToRefs(useMainStore())

const flipH = ref(false)
const flipV = ref(false)
const flipOptionsSelected = ref([])

const options = ref([
  { icon: 'IconFlipVertically', value: 'Vertical Flip', command: () => updateFlip({ flipV: !flipV.value }), constant: flipV.value },
  { icon: 'IconFlipHorizontally', value: 'Horizontal Flip', command: () => updateFlip({ flipH: !flipH.value }), constant: flipV.value }
])

watch(handleElement, () => {
  if (handleElement.value && (handleElement.value.type === 'image' || handleElement.value.type === 'shape')) {
    flipH.value = !!handleElement.value.flipH
    flipV.value = !!handleElement.value.flipV
  }
}, { deep: true, immediate: true })

const { addHistorySnapshot } = useHistorySnapshot()

const updateFlip = async (flipProps: ImageOrShapeFlip) => {
  if (!handleElement.value) return
  slidesStore.updateElement({ id: handleElement.value.id, props: flipProps })
  await api.savePresentation()
  addHistorySnapshot()
}
</script>

<style lang="scss" scoped>
</style>
